import { Button } from '../../Button'
import { Tooltip } from '../../../common/Tooltip/Tooltip'
import { ButtonProps } from '../../Button/Types'
import { Plus } from 'blaze-ui/icons'

export const AddApproverButton = ({ onPress }: Pick<ButtonProps, 'onPress'>) => (
  <Tooltip label="The review can’t end unless this person approves the doc." placement="top">
    <div>
      <Button onPress={onPress} frontIcon={Plus} size="md" variant="tertiary">
        Approver
      </Button>
    </div>
  </Tooltip>
)
